import { useState, useEffect } from 'react'

/**
 * Hook to detect if the viewport is mobile-sized (< md breakpoint / 768px)
 * Matches Tailwind's md breakpoint
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    // SSR-safe: default to false if window is not available
    if (typeof window === 'undefined') return false
    return window.innerWidth < 768
  })

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 767px)')
    
    const handleChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches)
    }

    // Set initial value
    setIsMobile(mediaQuery.matches)

    // Listen for changes
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return isMobile
}

